import React from "react";
import useEspecialidadesLogic from "./hooks/useEspecialidadesLogic";
import EspecialidadesView from "./pages/EspecialidadesView.jsx";

export default function Especialidades() {
  const logic = useEspecialidadesLogic();
  return <EspecialidadesView {...logic} />;
}
